export default "__VITE_ASSET__CJnR3tMj__"